/**
 * A signal for successful writes through the API client: consumers that show
 * server-side effects of a save (the sync pane) re-read soon after one instead
 * of waiting for their next poll.
 */
type Listener = () => void

const listeners = new Set<Listener>()

/** Subscribe; returns the unsubscribe. */
export function onApiMutation(listener: Listener): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

/** Called by the API client after a non-GET request succeeds. */
export function notifyApiMutation(): void {
  listeners.forEach((listener) => listener())
}
